import ServiceOptionRouting from '@/views/ServiceOptionRouting/index.vue'

const ServiceOptionRoutingRouter = {
  path: '/service-option-routing',
  name: 'ServiceOptionRouting',
  component: ServiceOptionRouting,
  props: (route) => ({
    secret: route.query.secret
  })
}

export default ServiceOptionRoutingRouter
